import { LoanCardTypeEnum } from '@/api/rights/types';
import ProductCommodity from '@/shared/commodity';
import type { ViewConfig } from '../../../ViewRegistry';
import YouSuCard from './index.vue';

export const youSuCardConfig: ViewConfig = {
  viewType: 'yousu-card',
  viewName: '优速卡购买卡片',
  component: YouSuCard as unknown as ViewConfig['component'],
  priority: 5,
  match: (context) => {
    // 匹配规则：产品ID不等于8180 && 不是外量外部闭环权益
    const productId = (context.channel)?.productId;
    const { rightSummaryData } = context;
    if (productId === undefined) return false;
    return (productId !== ProductCommodity.AUTARKY_B_COMMODITY)
    && (rightSummaryData?.loanCardType !== LoanCardTypeEnum.CHANNEL_RIGHT);
  },
  props: (context) => ({
    amount: context.amount,
    showSpeed: context.showSpeed,
    checkStatus: context.checkStatus,
    channel: context.channel,
    normalTextList: ['不可享受哈啰定制权益', '不可享受专属的吃喝玩乐权益'],
  }),
  description: '优速卡购买卡片',
};

export default youSuCardConfig;
